import classNames from 'classnames';
import { ButtonProps, SelectProps } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Omit } from '../../typings/utils';

import { EasyBooleanFilter } from './EasyBooleanFilter/EasyBooleanFilter';
import './EasyFilters.css';
import { EasyMultiSelect } from './EasyMultiSelect/EasyMultiSelect';
import { EasySelect } from './EasySelect/EasySelect';

export interface EasyFiltersProps {
    filters: Filter[];
    cls?: string;
    onChange?: (filtersState: {
        [name: string]: selectedFilters;
        filterChanged: string;
    }) => void;
    anchor?: HTMLDivElement;
}

export interface Filter
    extends Omit<Partial<ButtonProps & SelectProps>, 'type'> {
    name: string;
    type: filterType;
    selected: selectedFilters;
    items?: Item[];
    text?: string;
    optionalPlaceHolder?: boolean;
    cls?: string;
}

export enum filterType {
    boolean = 'boolean',
    multiSelect = 'multiSelect',
    select = 'select'
}

export type selectedFilters = string[] | string | boolean;

export interface Item {
    text: string;
    val: string;
}

export class EasyFilters extends React.Component<EasyFiltersProps> {
    private block = 'easy-filters';

    constructor(props: EasyFiltersProps) {
        super(props);
    }

    render(): React.ReactNode {
        const { filters, cls } = this.props;

        if (filters === undefined) {
            return null;
        }

        return (
            <div className={classNames(cls, Bem.cls(this.block))}>
                {filters.map(filter => {
                    return this.getFilter(filter);
                })}
            </div>
        );
    }

    private getFilter = (filter: Filter) => {
        const { type, optionalPlaceHolder } = filter;
        const filterValue = filter.selected ? filter.selected : [];
        const filterName = filter.name;
        const { anchor } = this.props;

        switch (type) {
            case filterType.boolean:
                return (
                    <EasyBooleanFilter
                        {...filter}
                        key={filterName}
                        name={filterName}
                        checked={
                            typeof filterValue === 'boolean'
                                ? filterValue
                                : false
                        }
                        text={filter.text ? filter.text : 'Filter'}
                        onChange={this.onFilterChange}
                    />
                );
            case filterType.select:
                return (
                    <EasySelect
                        {...filter}
                        key={filterName}
                        items={filter.items}
                        name={filterName}
                        value={
                            typeof filterValue !== 'boolean' ? filterValue : []
                        }
                        text={filter.text}
                        onChange={this.onFilterChange}
                        optionalPlaceHolder={optionalPlaceHolder}
                        anchor={anchor}
                    />
                );
            case filterType.multiSelect:
                return (
                    <EasyMultiSelect
                        {...filter}
                        key={filterName}
                        items={filter.items}
                        name={filterName}
                        value={
                            typeof filterValue !== 'boolean' ? filterValue : []
                        }
                        text={filter.text}
                        onChange={this.onFilterChange}
                        optionalPlaceHolder={optionalPlaceHolder}
                        anchor={anchor}
                    />
                );
            default:
                throw new Error(`Unsupported filter type: ${type}`);
        }
    };

    private onFilterChange = (
        val: string | string[] | boolean,
        name: string
    ) => {
        const { onChange, filters } = this.props;
        const filtersState = {};

        filters.map(filter => {
            const value = filter.selected;

            if (value) {
                filtersState[filter.name] = value;
            }
        });

        filtersState[name] = val;

        if (onChange) {
            onChange({ ...filtersState, filterChanged: name });
        }
    };
}
